"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _emotion = require("@rebass/grid/emotion");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var GridContainer = (
/*#__PURE__*/
0, _styledBase["default"])(_emotion.Flex, {
  target: "e7e4lmf0",
  label: "GridContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "ili12r",
  styles: "width:100%;max-width:1020px;margin:auto;padding:0 20px;justify-content:center;align-items:center;flex-direction:column;@media (min-width:768px){padding:0 40px;}"
} : {
  name: "ili12r",
  styles: "width:100%;max-width:1020px;margin:auto;padding:0 20px;justify-content:center;align-items:center;flex-direction:column;@media (min-width:768px){padding:0 40px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2lkZW50aXR5L2dyaWQtY29udGFpbmVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdrQyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9pZGVudGl0eS9ncmlkLWNvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xyXG5pbXBvcnQgeyBGbGV4IH0gZnJvbSBcIkByZWJhc3MvZ3JpZC9lbW90aW9uXCI7XHJcblxyXG5jb25zdCBHcmlkQ29udGFpbmVyID0gc3R5bGVkKEZsZXgpYFxyXG4gIHdpZHRoOiAxMDAlO1xyXG4gIG1heC13aWR0aDogMTAyMHB4O1xyXG4gIG1hcmdpbjogYXV0bztcclxuICBwYWRkaW5nOiAwIDIwcHg7XHJcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XHJcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcclxuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xyXG5cclxuICBAbWVkaWEgKG1pbi13aWR0aDogNzY4cHgpIHtcclxuICAgIHBhZGRpbmc6IDAgNDBweDtcclxuICB9XHJcbmA7XHJcblxyXG5leHBvcnQgZGVmYXVsdCBHcmlkQ29udGFpbmVyO1xyXG4iXX0= */"
});
var _default = GridContainer;
exports["default"] = _default;